import { Record as ImRecord, type RecordOf } from 'immutable';

import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';

export const CATEGORIES_REDUCER_KEY = 'categoryStore';
export type CATEGORIES_REDUCER_KEY = typeof CATEGORIES_REDUCER_KEY;

export enum CategoryTypeEnum {
  INCOME = 'INCOME',
  EXPENSE = 'EXPENSE',
}

export type CategoryType = `${CategoryTypeEnum}`;

export enum UsageTypeEnum {
  BUSINESS = 'BUSINESS',
  PERSONAL = 'PERSONAL',
  RENTAL = 'RENTAL',
  FARMING = 'FARMING',
}

export type TaxGroupType = {
  BUSINESS?: string;
  FARMING?: string;
  RENTAL_PROPERTY?: string;
};

export type TaxFormType = {
  id?: string;
  country?: string;
  txfId?: string;
  name?: string;
  description?: string;
  displayOrder?: number;
  primary?: boolean;
};

export type BusinessTaxInfoType = {
  taxForm?: string;
  taxLineItem?: string;
  enabled?: boolean;
};

// NOTE:  These are extra properties, not part of the QCS schema, required to manage the UI form state
export type ExtraProps = {
  taxRelated?: boolean;
  taxForm?: string;
  taxGroups?: TaxGroupType;
  businessTaxInfo?: BusinessTaxInfoType;
};

export type CategoryProps = {
  id?: string;
  clientId?: string;
  parentClientId?: string | null;
  parentId?: string;

  type?: CategoryType;
  // NOTE: QCS returns a categoryType field that we re-map to a type field in transformers
  categoryType?: CategoryType;
  name?: string;
  description?: string;

  usageType?: string;

  isNotEditable?: boolean;
  isNotUserAssignable?: boolean;

  isExcludedFromBudgets?: boolean;
  isExcludedFromCategoryList?: boolean;
  isExcludedFromReports?: boolean;

  knownCategoryId?: string | null;
  isInvestment?: boolean;

  logoUrl?: string;
  txfId?: string;
  txfIds?: Record<string, string> | null;

  isDeleted?: boolean;
  modifiedAt?: string;
} & ExtraProps;

export type Category = RecordOf<CategoryProps>;

// use when receive object from server side (QCS omit props containing default values, so need to handle defaults explicitly on the client)
export const mkCategory = ImRecord<CategoryProps>({
  id: undefined,
  parentId: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario
  parentClientId: undefined,
  clientId: undefined,

  type: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario
  name: undefined,
  description: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario

  usageType: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario

  isNotEditable: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario
  isNotUserAssignable: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario

  isExcludedFromReports: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario
  isExcludedFromCategoryList: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario
  isExcludedFromBudgets: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario

  logoUrl: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario
  txfId: '',
  txfIds: null,
  knownCategoryId: undefined, // TODO: SIMPL-24210 set valid default for QCS erase prop scenario

  isDeleted: undefined,
  modifiedAt: undefined,
});

export const KNOWN_CATEGORY_ID = {
  PERSONAL_INCOME: '5750000000',
  BUSINESS_INCOME: '1500000000',
  BILLABLE_EXPENSE_INCOME: '1500200000',
  DISCOUNTS_GIVEN: '1500400000',
  MARKUP: '1500600000',
  TIP_INCOME: '1500800000',
  FEDERAL_TAX: '7000100000',
  FEDERAL_ESTIMATED_TAX_PAYMENT: '7000050000',
} as const;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [CATEGORIES_REDUCER_KEY]: QcsSyncResourceStore<CategoryProps>;
  }
}

export type SubmitPayload = {
  category: CategoryProps;
};
